import {Button} from '@mui/material';
import MarkdownContentRenderer from '../../atoms/MarkdownContentRenderer/MarkdownContentRenderer';

export interface SessionQuestionAnswerListChoiceProps {
  text: string;
  isSelected: boolean;
  handleAnswerSelect: (option: string) => void;
  disabled: boolean;
}

export default function SessionQuestionAnswerListChoice({
  text,
  isSelected,
  handleAnswerSelect,
  disabled,
}: SessionQuestionAnswerListChoiceProps) {
  return (
    <Button
      variant={isSelected ? 'contained' : 'outlined'}
      onClick={() => handleAnswerSelect(text)}
      disabled={disabled}
      data-testid="answer-option"
      sx={{
        justifyContent: 'flex-start',
        textAlign: 'left',
        p: 2,
        height: 'auto',
        minHeight: 56,
      }}
    >
      <MarkdownContentRenderer content={text} />
    </Button>
  );
}
